// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__15it-","downloadButtons":"Privacy_downloadButtons__Q-RDi","navBar":"Privacy_navBar__3rNDe"};